import c from "react";
var m = Object.defineProperty,
  y = Object.defineProperties,
  w = Object.getOwnPropertyDescriptors,
  d = Object.getOwnPropertySymbols,
  O = Object.prototype.hasOwnProperty,
  E = Object.prototype.propertyIsEnumerable,
  f = (e, r, t) => r in e ? m(e, r, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: t
  }) : e[r] = t,
  b = (e, r) => {
    for (var t in r || (r = {})) O.call(r, t) && f(e, t, r[t]);
    if (d) for (var t of d(r)) E.call(r, t) && f(e, t, r[t]);
    return e;
  },
  P = (e, r) => y(e, w(r));
typeof window != "undefined" && !window.__DS_WEB_VERSION__ && (window.__DS_WEB_VERSION__ = "3.35.0");
const h = .0675,
  _ = 120,
  S = 4,
  x = "--color-secondary-100",
  N = "--color-neutral-130",
  D = "--color-neutral-110",
  j = .375,
  k = e => e > 100 ? 100 : e < -100 ? -100 : e,
  C = e => e <= 0 ? _ : e,
  u = _ref => {
    let {
      size: e = _,
      strokeWidth: r = S,
      fill: t = x,
      backgroundFill: i = D,
      internalValueColor: v = N,
      internalValue: n,
      percentage: p
    } = _ref;
    const o = C(e),
      l = o / 2,
      g = o * h,
      s = l - g,
      a = 2 * Math.PI * s;
    return c.createElement("div", P(b({
      className: n && "olx-progress-circle--internal-value",
      "data-ds-component": "DS-ProgressCircle"
    }, n && {
      "data-internal-value": n
    }), {
      style: {
        "--size": "".concat(o, "px"),
        "--internal-value-color": "var(".concat(v, ")"),
        "--font-size": "".concat(e * j, "px")
      }
    }), c.createElement("svg", {
      width: o,
      height: o
    }, c.createElement("circle", {
      className: "olx-progress-circle__svg",
      fill: i,
      r: s,
      cx: l,
      cy: l,
      style: {
        "--stroke": "var(".concat(i, ")"),
        "--stroke-width": r,
        "--circumference": a,
        "--percentage": 100,
        "--dash-offset": 0
      }
    }), c.createElement("circle", {
      className: "olx-progress-circle__svg",
      fill: t,
      r: s,
      cx: l,
      cy: l,
      style: {
        "--stroke": "var(".concat(t, ")"),
        "--stroke-width": r,
        "--circumference": a,
        "--percentage": k(p),
        "--dash-offset": a - p / 100 * a
      }
    })));
  };
u.displayName = "ProgressCircle";
export { u as ProgressCircle };